import React from 'react'
import { Flex } from 'antd'
import ImportDataPreviewStepItem from '../../../../components/SyncData/ImportDataPreviewStepItem'

interface Props {
  fileData?: any
}

const files = [
  {
    name: 'DDMS_Services_Customer_20240716.xls',
    columns: [
      {
        title: 'Họ và tên',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Giới tính',
        dataIndex: 'gender',
        key: 'gender',
      },
      {
        title: 'Số điện thoại',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Ngày sinh',
        dataIndex: 'dob',
        key: 'dob',
      },
    ],
    items: [
      {
        key: '1',
        name: 'Nguyễn Lê Hải Phong',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '2',
        name: 'Tuấn Lê',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
      {
        key: '3',
        name: 'Tuấn Hải',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '4',
        name: 'Minh Trần',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
      {
        key: '5',
        name: 'Hoàng Anh',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '6',
        name: 'Nguyễn Lê Hải Phong',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
    ]
  },
  {
    name: 'DDMS_Sale_Customer_20240716.xls',
    columns: [
      {
        title: 'Họ và tên',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Giới tính',
        dataIndex: 'gender',
        key: 'gender',
      },
      {
        title: 'Số điện thoại',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Ngày sinh',
        dataIndex: 'dob',
        key: 'dob',
      },
    ],
    items: [
      {
        key: '1',
        name: 'Nguyễn Lê Hải Phong',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '2',
        name: 'Tuấn Lê',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
      {
        key: '3',
        name: 'Tuấn Hải',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '4',
        name: 'Minh Trần',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
      {
        key: '5',
        name: 'Hoàng Anh',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '6',
        name: 'Nguyễn Lê Hải Phong',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
    ]
  },
  {
    name: 'DDMS_Sale_Customer_20240716.xls',
    columns: [
      {
        title: 'Họ và tên',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Giới tính',
        dataIndex: 'gender',
        key: 'gender',
      },
      {
        title: 'Số điện thoại',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Ngày sinh',
        dataIndex: 'dob',
        key: 'dob',
      },
    ],
    items: [
      {
        key: '1',
        name: 'Nguyễn Lê Hải Phong',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '2',
        name: 'Tuấn Lê',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
      {
        key: '3',
        name: 'Tuấn Hải',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '4',
        name: 'Minh Trần',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
      {
        key: '5',
        name: 'Hoàng Anh',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'abc@gmail.com',
        dob: '18/09/1990',
      },
      {
        key: '6',
        name: 'Nguyễn Lê Hải Phong',
        gender: 'Nam',
        phoneNumber: '039222345',
        email: 'xyz@gmail.com',
        dob: '01/01/1990',
      },
    ]
  },
]
const head = (data: any) => {
  const temp = [] as any
  Object.keys(data).map((iskey: any) => {
    temp.push({
      title: data[iskey].label,
      dataIndex: data[iskey].oriField,
      key: data[iskey].oriField,
      hidden: data[iskey].newField ? false : true,
    })
  })
  return temp
}

const rows = (data: any, head: any) => {
  const temp = [] as any
  const newhed = {} as any
  Object.keys(head).map((iskey: any) => {
    if (head[iskey].newField) {
      newhed[iskey] = head[iskey]
    }
  })
  data.map((val: any, index: any) => {
    const item = {} as any
    Object.keys(newhed).map((iskey: any) => {
      item[newhed[iskey].newField] = val[iskey]
    })
    temp.push(item)
  })
  return temp
}
const ImportDataPreviewStep:React.FC<Props> = (props) => {
  const { fileData } = props
  const fixSizeColumns = (columnsx: any) => {
    const columns = [...columnsx] as any
    const temp = [] as any
    columns.map((col: any) => {
      if (col.hidden) {
        return
      }
      temp.push({
        ...col,
        width: col.title ? Math.max(100, col.title.length * 16) : 100, // Độ rộng tối thiểu 100, mỗi ký tự ~16px
      })
    })
    return temp
  }
  return (
    <div className="import-data-step-3">
      <Flex vertical className='gap-24px'>
        {
          Object.keys(fileData).map((file: any) => (
            <ImportDataPreviewStepItem
              tableColumns={fixSizeColumns(head(fileData[file].obhead))}
              tableItems={fileData[file].allRowData}
              fileName={fileData[file].fileName}
              key={fileData[file].fileName}
            />
          ))
        }
      </Flex>
    </div>
  )
}

export default ImportDataPreviewStep
